import './Scrollable.scss';

import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { ResizeConsumer, ResizeProvider } from 'react-resize-context';

const Scrollable = ({ children, className }) => {
	const scrollBarRef = useRef(null);

	return (
		<ResizeProvider>
			<ResizeConsumer
				className={className}
				onSizeChanged={() => {
					if (scrollBarRef.current.updateScroll) {
						scrollBarRef.current.updateScroll();
					}
				}}
			>
				<PerfectScrollbar ref={scrollBarRef} className='viato__scrollable2'>
					{children}
				</PerfectScrollbar>
			</ResizeConsumer>
		</ResizeProvider>
	);
};

Scrollable.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string
};

Scrollable.defaultProps = {
	className: ''
};

export default Scrollable;
